import React from 'react';
import { PieChartCustomLegend } from '../../common/charts/PieChartCustomLegend';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';

interface IDocumentMeta {
  value: number;
  name: string;
  description: string;
}

interface DocumentExpiryCardProp {
  EdeData: IDocumentMeta[];
  onDocClick: (dta: string) => void;
}

export const DocumentExpiryCard: React.FC<DocumentExpiryCardProp> = ({ EdeData, onDocClick }) => {
  const legendData = EdeData.map((item) => ({ ...item, value: `${item.value}` }));
  return (
    <BaseCard title={'Employee Documents Expiry'} padding={'0 1.25rem 1.875rem'}>
      <PieChartCustomLegend
        name={'Expiry'}
        chartData={EdeData}
        legendData={legendData}
        height="300px"
        onDocClick={onDocClick}
      />
    </BaseCard>
  );
};
